import roFlag from './../layouts/Topbar/LanguageDropdown/flags/ro.png';
import enFlag from './../layouts/Topbar/LanguageDropdown/flags/us.png';

export type Language = {
    code: string;
    name: string;
    flag: string;
};

export const Languages: Language[] = [
    {
        code: 'ro',
        name: 'Română',
        flag: roFlag,
    },
    {
        code: 'en',
        name: 'English',
        flag: enFlag,
    },
];

export type AppItem = {
    name: string;
    icon: string;
    redirectTo: string;
};

type Message = {
    id: number;
    title: string;
    time?: string;
    subText: string;
    avatar?: string;
    icon?: string;
    variant?: string;
    isRead: boolean;
};

export type NotificationItem = {
    day: string;
    messages: Message[];
};

export type ProfileOption = {
    key: string;
    icon: string;
    redirectTo: string;
};

export type SearchOption = {
    label: string;
    icon?: string;
    type: string;
    value?: string;
    userDetails?: {
        firstname: string;
        lastname: string;
        position: string;
        avatar: string;
    };
};
